import type { ReceiptTemplate } from '../schema';

export const uberEatsTemplate: ReceiptTemplate = {
  id: 'uber-eats',
  name: 'Uber Eats Receipt',
  brand: 'UBER EATS',
  description: 'Uber Eats food delivery receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ue-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/uber-eats.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          'DELIVERY RECEIPT',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ue-order',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'order', label: 'Order:', value: 'UE-847291' },
          { id: 'date', label: 'Date:', value: '01/04/2026' },
        ],
        column2: [
          { id: 'time', label: 'Time:', value: '7:45 PM' },
          { id: 'driver', label: 'Driver:', value: 'Mike W.' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ue-restaurant',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'left',
        message: 'FROM: CHIPOTLE MEXICAN GRILL\n1200 Dark Avenue',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'ue-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'BURRITO BOWL', quantity: '1', price: '11.75', sku: '' },
          { id: '2', name: 'CHIPS & GUAC', quantity: '1', price: '5.95', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ue-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '17.70', isBold: false, isLarge: false },
          { id: 'delivery', label: 'DELIVERY FEE', value: '2.99', isBold: false, isLarge: false },
          { id: 'service', label: 'SERVICE FEE', value: '3.54', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '2.00', isBold: false, isLarge: false },
          { id: 'tip', label: 'TIP', value: '4.00', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '30.23', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ue-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ue-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'DELIVERED TO:\n1200 Dark Avenue\nMonsterville, CA 94608\n\nTHANK YOU FOR ORDERING',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

